import { render } from "./simpeg-naik-pangkat-list-virtual-scroll.vue?vue&type=template&id=357a2fcb"
import script from "./simpeg-naik-pangkat-list-virtual-scroll.vue?vue&type=script&lang=js"
export * from "./simpeg-naik-pangkat-list-virtual-scroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__